<template>
  <div class="zs-login">
    <div class="zs-form-bg"></div>
    <div class="zs-form-warp">
      <el-form
        ref="form"
        status-icon
        :model="loginForm"
        :rules="rules">
        <p class="zs-title">{{ title }}</p>
        <el-form-item prop="account">
          <el-input
            ref="accountInput"
            v-model="loginForm.account"
            size="large"
            placeholder="用户名"
            autofocus
            @keyup.enter.native="submitUser"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            size="large"
            placeholder="密码"
            type="password"
            @keyup.enter.native="submitUser"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 30px">
          <el-button
            size="large"
            round
            :loading="loading"
            type="primary"
            @click="submitUser">
            登&nbsp;&nbsp;&nbsp;&nbsp;录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="put-on-record">
      <div style="transform: translateX(50%);">
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
        >备案号：粤ICP备2022025417号</a>
        <img :src="baPng" />
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44512202000057"
          target="_blank"
        >粤浙公网安备44512202000057号</a>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import './index.styl'
const baPng = require('@/assets/images/beian.png')
export default {
  name: 'LoginForm',
  components: {},
  props: {
    title: [String]
  },
  data() {
    return {
      baPng,
      redirct: '',
      loading: false,
      loginForm: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        password: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.redirct = this.$route.query.redirct
  },
  methods: {
    submitUser() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          const timestamp = +new Date()
          const { account, password } = this.loginForm
          const post = md5.hex(md5.hex(account + password) + timestamp)
          this.$store.dispatch('account/login', {
            payload: {
              account: account,
              password: post,
              timestamp: timestamp
            },
            success: url => {
              this.loading = false
              if (this.redirct) {
                this.$router.push({ path: this.redirct })
              } else {
                this.$router.push({ path: url })
              }
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .put-on-record {
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 13px;
    color: #111;
    display: flex;
    flex-direction column
    align-items: center;
    justify-content: center;

    a {
      color: #111;
    }

    img {
      margin: 0 4px;
    }
  }
</style>
